import React, { useEffect, useRef, useState } from "react";
import DropDownIcon from "../../assets/drop-down.svg";

const FormSelect = ({
  label,
  id,
  options = [],
  defaultValue = "",
  placeholder,
  emptyByDefault = true,
  className = "",
  labelClassName = "",
  selectClassName = "",
  onChange,
  ...props
}) => {
  const rootRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const selectedOption = options.find((option) => option.value === selectedValue);
  const displayText =
    selectedOption?.label || (emptyByDefault ? placeholder || "" : options[0]?.label || "");

  const handleSelect = (optionValue) => {
    setSelectedValue(optionValue);
    setIsOpen(false);

    if (typeof onChange === "function") {
      onChange(optionValue);
    }
  };

  return (
    <div ref={rootRef} className={className}>
      {label ? (
        <label className={`block leading-5 text-black ${labelClassName}`} htmlFor={id}>
          {label}
        </label>
      ) : null}

      <div className="relative mt-[15px]">
        <button
          id={id}
          type="button"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((current) => !current)}
          className={`h-[45px] w-full rounded-lg border border-[#938A96] bg-transparent px-3 pr-8 text-left text-black outline-none ${selectClassName}`}
          {...props}
        >
          <span className={displayText ? "block truncate" : "block text-transparent"}>
            {displayText || "_"}
          </span>
        </button>

        <span className="pointer-events-none absolute right-3 top-1/2 flex -translate-y-1/2 items-center justify-center">
          <img
            src={DropDownIcon}
            alt=""
            aria-hidden="true"
            className="block h-[9px] w-2.5"
          />
        </span>

        {isOpen ? (
          <div
            role="listbox"
            className="absolute left-0 top-full z-20 mt-2 max-h-60 w-full overflow-auto rounded-lg border border-[#938A96] bg-white shadow-[0_8px_24px_0_rgba(0,0,0,0.12)]"
          >
            {options.map((option) => {
              const isSelected = option.value === selectedValue;

              return (
                <button
                  key={option.value}
                  type="button"
                  role="option"
                  aria-selected={isSelected}
                  onClick={() => handleSelect(option.value)}
                  className={`block w-full px-3 py-3 text-left  text-black transition-colors duration-150 hover:bg-[#F5F5F5] ${
                    isSelected ? "bg-[#F5F5F5]" : ""
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FormSelect;